<script setup>
  import { computed, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useUserStore } from "@/stores/UserStore";
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';
  import RadioControl from '@/components/RadioControl.vue';

  const userStore = useUserStore();
  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const { t } = useI18n();

  watch(() => userStore.unitsTemp, (value) => {
    googleAnalyticsStore.sendEvent('User_Units_Change', {
      Type: 'Temperature',
      Value: value,
    });
  });

  const options = computed(() => ({
    f: t('siteSettings.fahrenheit'),
    c: t('siteSettings.celsius')
  }));
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'unit-temp-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="userStore.unitsTemp"
                name="unit-temp"
                :id="'unit-temp-' + value"
                :value="value"
                :srLabel="t('siteSettings.srSelectTemperatureUnit', { label })"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
